import { render } from "./StepsCounter.vue?vue&type=template&id=34f67236&ts=true"
import script from "./StepsCounter.vue?vue&type=script&lang=ts"
export * from "./StepsCounter.vue?vue&type=script&lang=ts"

import "./StepsCounter.vue?vue&type=style&index=0&id=34f67236&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__